import { Button } from '@sara/ui/components/button';
import { useDialog } from '@sara/ui/hooks/use-dialog';
import { Plus } from 'lucide-react';
import { useActiveOrganization } from '../../contexts/auth';
import { NewRubricDialog, RubricListContainer } from '../../contexts/rubrics';
import { PageHeader } from '../../components/page-header';

export function RubricsPage() {
  const { organization } = useActiveOrganization();
  const newRubricDialog = useDialog(NewRubricDialog);

  return (
    <div className="space-y-12">
      <PageHeader
        title="Rubrics"
        description="Versioned scoring rubrics attached to templates to evaluate conversations."
        action={
          organization && (
            <Button
              variant="tinted"
              shape="pill"
              size="sm"
              className="h-8 gap-1.5 px-3 text-xs [&_svg]:size-3.5 sm:h-9 sm:px-4 sm:text-sm sm:[&_svg]:size-4"
              onClick={() => newRubricDialog.open({ orgId: organization.id })}
            >
              <Plus strokeWidth={1.6} />
              New rubric
            </Button>
          )
        }
      />

      {organization && <RubricListContainer orgId={organization.id} />}
    </div>
  );
}
